import { LeasesBasicDetails, LeasesNav } from '../../elements';
import InvoiceHeaderConfig from '../components/InvoiceHeaderConfig';
import BusinessDaysConfig from '../components/BusinessDaysConfig';
import ManagementFeeConfiguration from '../components/ManagementFeeConfiguration';
import { Grid, Paper } from '@mui/material';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { gaTelesisInstance } from '../../../shared_elements';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import AccessDeniedMessage from '../../elements/AccessDeniedMessage';

const LeaseSettings = () => {
  const { permission } = useSelector((state) => state.leases);
  const leaseRevampPermissions = permission?.permissions?.lease_revamp_application?.lease_revamp;
  const hasAnySettingsPermission = ['calendar', 'management_fee_config', ...(gaTelesisInstance ? ['invoices'] : [])].some(feature =>
    leaseRevampPermissions?.[feature]?.includes('R')
  );

  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Lease Settings' })
  }, []);

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
        <LeasesNav />
        {!hasAnySettingsPermission ? (
          <div className='lease-details-content'>
            <AccessDeniedMessage />
          </div>
        ) : (
          <div className='lease-details-content lease-content-overflow'>
            <Paper square className="responsive-paper">
              <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                <Grid item md={4} xs={12} className="menu-container lease-list-link-mt">
                  <BackToLeaseList />
                </Grid>
                <Grid item md={8} xs={12} mb={1}></Grid>
              </Grid>
            </Paper>
            <div className='lease-detail-table' style={{ overflowY: 'auto', height: 'calc(100vh - 200px)', padding: '3px' }}>
              <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calendar", operationType: ['R'] }}>
                <BusinessDaysConfig />
              </PermissionWrapper>
              <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "management_fee_config", operationType: ['R'] }}>
                <ManagementFeeConfiguration />
              </PermissionWrapper>
              <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['R'] }}>
                {gaTelesisInstance && <InvoiceHeaderConfig />}
              </PermissionWrapper>
            </div>
          </div>
        )}
      </Paper>
    </>
  );
};

export default LeaseSettings;
